// API Configuration - Centralized backend endpoint management
// Environment variables with fallbacks for development

const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

// API Endpoints
export const API_ENDPOINTS = {
  FIRST_MESSAGE: `${BACKEND_BASE_URL}${process.env.REACT_APP_FIRST_MESSAGE_ENDPOINT || '/first_message'}`,
  PERSONA: `${BACKEND_BASE_URL}${process.env.REACT_APP_PERSONA_ENDPOINT || '/persona'}`,
  PERSONA_SWITCH: `${BACKEND_BASE_URL}${process.env.REACT_APP_PERSONA_SWITCH_ENDPOINT || '/persona_switch'}`,
  SYSTEM_DESIGN: `${BACKEND_BASE_URL}${process.env.REACT_APP_SYSTEM_DESIGN_ENDPOINT || '/system_design'}`,
  SUMMARIZE: `${BACKEND_BASE_URL}${process.env.REACT_APP_SUMMARIZE_ENDPOINT || '/summarize'}`,
  TOPIC: `${BACKEND_BASE_URL}${process.env.REACT_APP_TOPIC_ENDPOINT || '/topic'}`,
  HEALTH: `${BACKEND_BASE_URL}${process.env.REACT_APP_HEALTH_ENDPOINT || '/health'}`,
  WEB_SEARCH: `${BACKEND_BASE_URL}${process.env.REACT_APP_WEB_SEARCH_ENDPOINT || '/web_search'}`,
  // File upload endpoints
  FILES_UPLOAD_URL: `${BACKEND_BASE_URL}/api/files/upload-url`,
  FILES_GET: `${BACKEND_BASE_URL}/api/files/file`,
  FILES_DELETE: `${BACKEND_BASE_URL}/api/files/file`,
  FILES_LIST: `${BACKEND_BASE_URL}/api/files/files`,
  CONTACT: `${BACKEND_BASE_URL}/api/contact`,
} as const;

// API Configuration object for easy access
export const API_CONFIG = {
  baseUrl: BACKEND_BASE_URL,
  endpoints: API_ENDPOINTS,
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000'),
} as const;

// Type for API endpoints
export type ApiEndpoint = keyof typeof API_ENDPOINTS;

// Helper function to get endpoint URL
export const getApiUrl = (endpoint: ApiEndpoint): string => {
  return API_ENDPOINTS[endpoint];
};

// Helper function to make API requests with consistent configuration
export const apiRequest = async (
  endpoint: ApiEndpoint,
  options: RequestInit = {}
): Promise<Response> => {
  const url = getApiUrl(endpoint);
  
  const defaultOptions: RequestInit = {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  };

  return fetch(url, defaultOptions);
}; 

export function getAppVersion(): string {
  // Try build-time environment variable first (works during build)
  if (process.env.REACT_APP_VERSION) {
    return process.env.REACT_APP_VERSION;
  }
  
  // Fallback to runtime config (for development)
  if ((window as any).ENV_CONFIG?.APP_VERSION) {
    return (window as any).ENV_CONFIG.APP_VERSION;
  }
  
  // Final fallback
  return '1.0.0';
} 